<template>
  <div>
    <h5 class="mt-2 mb-4">{{ $t('launch.chat.message') }}</h5>

    <div v-if="getChatWidgetConfiguration" class="row mb-5 ml-2">
      <h6 :class="textColorClass">{{ $t('launch.chat.toggle') }}</h6>
      <cvt-switch
        size="sm"
        color="active"
        type="circular"
        description-type="default"
        :initial-state="chatToggleState"
        mode="LIGHT"
        @switchToggle="onSwitchToggle"
      />
    </div>
    <p v-if="!getChatWidgetConfiguration">
      {{ $t('launch.chat.disabled_message') }}
    </p>
  </div>
</template>

<script>

import { mapActions, mapGetters, mapState } from 'vuex';
import * as actions from '../../../../store/modules/actions';
import * as getters from '../../../../store/modules/getters';
import { CookieHelper } from '../../../../store/services/cookieHelper';

export default {
  name: 'TenantChatWidget',
  data() {
    return {
      chatToggleState: false,
    }
  },
  computed: {
    ...mapGetters({
      config: getters.AUTH_GET_USER_CONFIG,
      chatWidgetConfig: getters.CHAT_WIDGET_CONFIG,
      site: getters.SITE_GET_DATA
    }),
    ...mapState('globalTheme', {
      RadioButtonShape: ({ globalTheme }) =>
        globalTheme.RadioButtonShape !== undefined
          ? globalTheme.RadioButtonShape
          : '',
    }),
    textColorClass() {
      return { 'text-white': this.mode == 'DARK', 'mr-3': true, 'pt-1': true }
    },
    chatEnabled() {
      const isSameSiteChatEnabled = this.chatWidgetConfig.siteID === this.site.id
      return Boolean(
        Object.keys(this.chatWidgetConfig) &&
          this.chatWidgetConfig?.ConversationKey && isSameSiteChatEnabled
      )
    },
    getChatWidgetConfiguration() {
      const session = CookieHelper('_pages_session=')
      const { chatWidgetConfiguration } = session
      return {...chatWidgetConfiguration, siteID: this.site.id}
    },
  },
  created: async function () {
    this.chatToggleState = this.chatEnabled
  },
  methods: {
    ...mapActions({
      updateChatWidgetConfiguration: actions.UPDATE_CHAT_WIDGET_CONFIG,
    }),
    async onSwitchToggle() {
      await this.updateChatWidgetConfiguration(
        this.chatToggleState ? {} : this.getChatWidgetConfiguration,
      )
      this.chatToggleState = !this.chatToggleState
    },
  },
}
</script>
